import { useContext, useEffect, useState } from "react"

import StoryblokLink from "../link/StoryblokLink"
import { ActionBar } from "./actionBar/actionBar"
import ThemeToggle from "../themeToggle/themeToggle"
import StoryblokImageBasic from "../storyblokImageBasic/storyblokImageBasic"
import SearchBar from "./searchBar/searchBar"
import { AccountMenuMobileButton } from "./accountMenu/accountMenu"

import { NavbarContext, NavbarContextProvider } from "./navbarContext"
import { useStoryblokNavigation } from "../../hooks/useStoryblokNavbar"
import { BarsSVG, CrownSVG, SearchSVG, TimesMiniSVG, TimesSVG, TriangleDownSVG } from "../../svg"
import { GetStoryLanguage } from "../../helpers/storyHelpers"

import styles from "./navbar.module.scss"


function NavbarWrapper({ story, story_language }) {

  return (
    <NavbarContextProvider>
      <Navbar
        story={story}
        story_language={story_language} />
    </NavbarContextProvider>
  )
}

function Navbar({ story, story_language }) {
  const navStory = useStoryblokNavigation(story_language),
        navContext = useContext(NavbarContext),
        [currentHoverItemUid, setCurrentHoverItemUid] = useState(),
        [currentClickItemUid, setCurrentClickItemUid] = useState()

  const navbarStory = story || navStory;

  function handleHoverItem(itemUid) {
    if(currentHoverItemUid !== itemUid) {
      setCurrentHoverItemUid(itemUid)
    }
  }
  function handleLeaveItem(itemUid) {
    if(currentHoverItemUid === itemUid) {
      setCurrentHoverItemUid(null)
    }
  }
  function handleClickItem(itemUid) {
    setCurrentClickItemUid(currentClickItemUid === itemUid ? null : itemUid)
  }

  function openSideNav() {
    navContext.toggleSidebar()
  }
  function closeSideNav() {
    navContext.toggleSidebar()
  }

  return (
    <>
      <div className={styles.navheight} />
      <nav className={`${styles.navheight} ${styles.navbar}`}>
        <div className={styles.searchCover}>
          {navbarStory ? (
            <ActionBar
              back_to_main_message={navbarStory.content.back_to_main_label}
              back_to_main_link={navbarStory.content.back_to_main_link}
              premium_message={navbarStory.content.premium_button_text}
              premium_link={navbarStory.content.premium_button_link}
            />
          ) : null}
          <div className="view with-padding">
            <div className={`page-content ${styles.pageContent} ${navContext.account_menu_is_visible ? styles.withUnderline : ""}`}>
              {/* Nav goes here */}
              {navbarStory ? (
                <div className={styles.mainContent}>
                  <div className={styles.mobileLeftContent}>
                    <button className={styles.menuButton} onClick={openSideNav}>
                      <BarsSVG />
                    </button>
                    <div className={styles.logo}>
                      <StoryblokLink linkObject={navbarStory.content.logo_link}>
                        <StoryblokImageBasic image={navbarStory.content.logo} />
                      </StoryblokLink>
                    </div>
                  </div>
                  <div className={`${styles.mainListWrapper} ${navContext.mobile_sidebar_is_visible ? styles.sidenavOpen : ""}`}>
                    <div className={styles.mainListBackdrop} onClick={closeSideNav} />
                    <div className={styles.sidenavContent}>
                      <div className={styles.sidenavOnly}>
                        <button className={styles.sidenavCloseButton} onClick={closeSideNav}><TimesSVG /></button>
                      </div>
                      <ul className={styles.mainList}>
                        {navbarStory.content.mobile_home_link_label ? (
                          <li key="mobile-home-link" className={styles.sidenavOnly}>
                            <StoryblokLink linkObject={navbarStory.content.mobile_home_link} className={styles.mainListLink}>
                              {navbarStory.content.mobile_home_link_label}
                            </StoryblokLink>
                          </li>
                        ) : null}
                        {navbarStory.content.items.map((navItem)=>{
                          if(navItem.items && navItem.items.length > 0) {
                            return (
                              <li 
                                key={navItem._uid} 
                                className={`${styles.mainListItem} ${styles.withTriangle} ${currentHoverItemUid === navItem._uid ? styles.dropdownItemActive : ""} ${currentClickItemUid === navItem._uid ? styles.dropdownItemClickActive : ""}`} 
                                onMouseEnter={(e)=>{e.preventDefault();handleHoverItem(navItem._uid);}} 
                                onMouseLeave={(e)=>{e.preventDefault();handleLeaveItem(navItem._uid);}}
                                onClick={(e)=>{handleClickItem(navItem._uid)}}
                              >
                                <div className={styles.listWithTriangleContainer}>
                                  <div className={styles.mainListLink}>
                                    <span className={styles.label}>{navItem.label}</span><TriangleDownSVG />
                                  </div>
                                  <div className={styles.dropdown}>
                                    <ul className={styles.submenu}>
                                      {navItem.items.map((item)=>(
                                        item && <li key={item?._uid} className={styles.submenuItem}>
                                          <StoryblokLink linkObject={item.link} activeClass={styles.highlight}>
                                            {item.label}
                                          </StoryblokLink>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                </div>
                              </li>
                            )
                          } else {
                            return (
                              <li key={navItem._uid}>
                                <StoryblokLink linkObject={navItem.link} className={styles.mainListLink} activeClass={styles.highlight}>
                                  {navItem.label}
                                </StoryblokLink>
                              </li>
                            )
                          }
                        })}
                      </ul>
                      <div className={styles.sidenavOnly} >
                        <StoryblokLink className={styles.fullWidthTealLink} linkObject={navbarStory.content.back_to_main_link}>{navbarStory.content.back_to_main_label_mobile}</StoryblokLink>
                        <div className={styles.darkContent}>
                          <div className={styles.darkContentLeft}>
                            <div><ThemeToggle /></div>
                          </div>
                          <div className={styles.mobileCrown}>
                            <a href="#"><CrownSVG /></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.navbarContentRight}>
                    <AccountMenuMobileButton withClass={styles.navbarMenuButton} />
                    <button className={`${styles.searchButton} ${navContext.search_is_visible ? styles.searchButtonOpen : ""}`} onClick={(e)=>{e.preventDefault();navContext.toggleSearch()}}>
                      {navContext.search_is_visible ? <TimesMiniSVG /> : <SearchSVG /> } 
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          <div className={navContext.account_menu_is_visible ? styles.mobileNoBorder : styles.border} />
        </div>
        <SearchBar />
      </nav>
    </>
  )
}


export default NavbarWrapper
